/**
 * @file flights.api.js
 * @module FlightsAPI
 * @description HTTP API wrapper for flights-related endpoints (info, lookups). Methods return Axios promises.
 */

import { axiosInstance } from "./axios";

export const FlightsAPI = {
    /**
     * Validate a flight number for a given date.
     * @param {string} flightNumber - Flight number to validate.
     * @param {string} date - Date string in YYYY-MM-DD format.
     * @param {string} [token=''] - Optional auth token.
     * @returns {Promise} Axios promise resolving to validation/flight info.
     */
    fetchScheduledFlights: (flightNumber, date, token = "") => {
        return axiosInstance(token).get(`/flights/${date}/${flightNumber}`);
    },

    /**
     * Get flights information by aircraft ident.
     * @param {string} ident - Aircraft ident.
     * @param {string} [token=''] - Optional auth token.
     * @returns {Promise} Axios promise resolving to flights information.
     */
    getFlightsInformationByIdent: (ident, token = "") => {
        return axiosInstance(token).get(`/flights-information/${ident}`);
    }
}
